import React from 'react';
import { Box } from '@mui/material';
import StatContainer from './StatContainer';

const StatsGrid = ({ stats }) => {
  // Add debugging to see what data is being received
  console.log('StatsGrid received stats:', stats);
  console.log('StatsGrid linkTaps value specifically:', stats.linkTaps);
  console.log('StatsGrid linkTaps.value specifically:', typeof stats.linkTaps === 'object' ? stats.linkTaps.value : stats.linkTaps);

  // Get contactsDownloaded value with fallbacks
  const contactsDownloadedValue =
    // If it's an object with value property
    (stats.contactsDownloaded && typeof stats.contactsDownloaded === 'object' && stats.contactsDownloaded.value !== undefined)
      ? stats.contactsDownloaded.value
      // If it's a direct number
      : (typeof stats.contactsDownloaded === 'number')
        ? stats.contactsDownloaded
        // Fallback to 0
        : 0;

  // Get percentage with fallbacks  
  const contactsDownloadedPercentage =
    (stats.contactsDownloaded && typeof stats.contactsDownloaded === 'object' && stats.contactsDownloaded.percentage !== undefined)
      ? stats.contactsDownloaded.percentage
      : 0;

  // Get trend with fallbacks
  const contactsDownloadedTrend =
    (stats.contactsDownloaded && typeof stats.contactsDownloaded === 'object' && stats.contactsDownloaded.trend)
      ? stats.contactsDownloaded.trend
      : 'neutral';

  console.log('Contacts Downloaded processed value:', {
    value: contactsDownloadedValue,
    percentage: contactsDownloadedPercentage,
    trend: contactsDownloadedTrend
  });

  const defaultStats = [
    {
      title: 'Leads Generated',
      value: typeof stats.leadsGenerated === 'object' ? stats.leadsGenerated.value : stats.leadsGenerated,
      percentage: typeof stats.leadsGenerated === 'object' ? stats.leadsGenerated.percentage : 0,
      trend: typeof stats.leadsGenerated === 'object' ? stats.leadsGenerated.trend : 'up',
      info: 'Total number of leads generated in the selected time period'
    }, {
      title: 'Link taps',
      value: typeof stats.linkTaps === 'object' ? stats.linkTaps.value : (stats.linkTaps || 0),
      percentage: typeof stats.linkTaps === 'object' ? stats.linkTaps.percentage : 0,
      trend: typeof stats.linkTaps === 'object' ? stats.linkTaps.trend : 'up',
      info: 'Number of times your links were tapped'
    },
    {
      title: 'Card Views',
      value: typeof stats.cardViews === 'object' ? stats.cardViews.value : stats.cardViews,
      percentage: typeof stats.cardViews === 'object' ? stats.cardViews.percentage : 0,
      trend: typeof stats.cardViews === 'object' ? stats.cardViews.trend : 'up',
      info: 'Number of times your cards were viewed'
    },
    {
      title: 'Contacts Downloaded',
      value: contactsDownloadedValue,
      percentage: contactsDownloadedPercentage,
      trend: contactsDownloadedTrend,
      info: 'Number of times your contact was downloaded'
    }
  ];

  return (
    <Box
      sx={{
        width: '100%',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '16px'
      }}
    >
      {defaultStats.map((stat, index) => (
        <StatContainer key={index} {...stat} />
      ))}
    </Box>
  );
};

export default StatsGrid;